import { gql } from "@apollo/client";

// How an in-house mobile officer works, his keys and availability (wfc-server MobileOfficerService)
export const mobileOfficerProfileQuery = gql`
  query($employeeId: String!) {
    mobileOfficerProfile(employeeId: $employeeId)
  }
`;

export const setMobileOfficerProfileMutation = gql`
  mutation($employeeId: String!, $input: MobileOfficerProfileInput!) {
    setMobileOfficerProfile(employeeId: $employeeId, input: $input)
  }
`;

// every mobile job type with the company's report form for it, and the forms to choose from
export const mobileReportFormsQuery = gql`
  query {
    mobileReportForms
  }
`;

export const setMobileReportFormMutation = gql`
  mutation($dutyTypeId: String!, $reportTemplateId: String) {
    setMobileReportForm(dutyTypeId: $dutyTypeId, reportTemplateId: $reportTemplateId)
  }
`;

export const companyOnboardingQuery = gql`
  query {
    companyOnboarding
  }
`;

export const saveOnboardingStepMutation = gql`
  mutation($step: String!, $data: JSON) {
    saveOnboardingStep(step: $step, data: $data)
  }
`;

export const completeOnboardingMutation = gql`
  mutation {
    completeOnboarding
  }
`;

// Mobile Services > New task, In-House: the direct-jobs mobile drivers to give it to
export const directMobileDriversQuery = gql`
  query {
    directMobileDrivers
  }
`;
